import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { RegAction, GoogleLoginAction } from '../../action';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginButton from '../Common/GoogleLoginBtn';
import Toasts from '../Common/Toasts';
import Header from '../../component/Header';
import Footer from '../../component/Footer';

const clientId = process.env.REACT_APP_GOOGLE_API_KEY;

const isRegUnavailableMessage = (message) =>
  String(message || '').includes('Regjistrimi nuk është i mundur');

export default function Reg() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const regUsers = useSelector((state) => state.productData.users);
  const regAttempted = useRef(false);
  const [unavailableOpen, setUnavailableOpen] = useState(false);
  const [unavailableMessage, setUnavailableMessage] = useState('');
  const [dobFocused, setDobFocused] = useState(false);

  const notifyErr = (message) => toast.error(message || 'Llogaria ekziston tashmë');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const dobValue = watch('dob');
  const dobRegister = register('dob', { required: true });

  const handleGoogleResponse = async (response) => {
    regAttempted.current = true;
    try {
      const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${response.access_token}`,
        },
      });

      const userInfo = await res.json();

      dispatch(GoogleLoginAction({
        email: userInfo.email,
        gtoken: response.access_token,
        googleid: userInfo.sub,
        fname: userInfo.given_name,
        lname: userInfo.family_name,
      }));
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const onSubmit = (data) => {
    regAttempted.current = true;
    const payload = {
      fname: data.fname,
      lname: data.lname,
      email: data.email,
      address: data.address,
      city: data.city,
      dateOfBirth: data.dob,
      gender: data.gender,
      phoneNumber: data.phone,
      password: data.password,
      role: 'Buyer',
    };
    dispatch(RegAction(payload));
  };

  const continueAsGuest = () => {
    setUnavailableOpen(false);
    navigate('/');
  };

  useEffect(() => {
    if (regUsers?.token?.length > 0) {
      navigate('/');
      return;
    }

    if (!regAttempted.current) return;

    if (regUsers?.message && !regUsers?.token) {
      if (isRegUnavailableMessage(regUsers.message)) {
        setUnavailableMessage(regUsers.message);
        setUnavailableOpen(true);
      } else {
        notifyErr(regUsers.message);
      }
      regAttempted.current = false;
    }
  }, [regUsers]);

  return (
    <>


      <div className="min-h-screen bg-white flex flex-col">
        <Toasts />
        <Header />

        <main className="flex-grow flex items-start justify-center px-4 pt-6 pb-10">
          <div className="w-full max-w-3xl bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] rounded-2xl p-4 sm:p-6">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-black">Krijoni Llogari</h2>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Emri"
                    {...register("fname", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
                  />
                  {errors.fname && <p className="text-red-600 text-sm mt-1">Kërkohet Emri</p>}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Mbiemri"
                    {...register("lname", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
                  />
                  {errors.lname && <p className="text-red-600 text-sm mt-1">Kërkohet Mbiemri</p>}
                </div>
              </div>

              <input
                type="email"
                placeholder="Email"
                {...register("email", { required: true })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
              />
              {errors.email && <p className="text-red-600 text-sm mt-1">Kërkohet Email</p>}

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Numri i telefonit"
                    {...register("phone", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
                  />
                  {errors.phone && <p className="text-red-600 text-sm mt-1">Kërkohet numri</p>}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Adresa"
                    {...register("address", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
                  />
                  {errors.address && <p className="text-red-600 text-sm mt-1">Kërkohet Adresa</p>}
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Qyteti"
                    {...register("city", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
                  />
                  {errors.city && <p className="text-red-600 text-sm mt-1">Kërkohet Qyteti</p>}
                </div>
                <div>
                  <div className="relative">
                    <input
                      id="dob"
                      type="date"
                      {...dobRegister}
                      onFocus={() => setDobFocused(true)}
                      onBlur={(e) => {
                        setDobFocused(false);
                        dobRegister.onBlur(e);
                      }}
                      className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white ${
                        dobFocused || dobValue
                          ? "text-black"
                          : "text-transparent [&::-webkit-datetime-edit]:text-transparent"
                      }`}
                    />
                    {!dobFocused && !dobValue && (
                      <span className="pointer-events-none absolute inset-y-0 left-4 flex items-center text-gray-400">
                        Data e lindjes
                      </span>
                    )}
                  </div>
                  {errors.dob && <p className="text-red-600 text-sm mt-1">Kërkohet Data e lindjes</p>}
                </div>
              </div>

              <div>
                <select
                  {...register("gender", { required: true })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-500 focus:ring-2 focus:ring-black/30 bg-white"
                >
                  <option value="">Zgjidh gjininë</option>
                  <option value="Male">Mashkull</option>
                  <option value="Female">Femër</option>
                </select>
                {errors.gender && <p className="text-red-600 text-sm mt-1">Kërkohet Gjinia</p>}
              </div>

              <input
                type="password"
                placeholder="Fjalëkalimi"
                {...register("password", { required: true, minLength: 8 })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black/30 bg-white text-black"
              />
              {errors.password?.type === "required" && <p className="text-red-600 text-sm mt-1">Kërkohet Fjalëkalimi</p>}
              {errors.password?.type === "minLength" && <p className="text-red-600 text-sm mt-1">Fjalëkalimi duhet të ketë së paku 8 karaktere</p>}

              <button
                type="submit"
                className="w-full mt-4 bg-black hover:bg-neutral-800 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition"
              >
                <span>Regjistrohu</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 9l3 3-3 3m8-3H3" />
                </svg>
              </button>
            </form>

            <div className="mt-6 text-center text-sm text-gray-700">Ose</div>
            <div className="w-full mt-4">
              <GoogleOAuthProvider clientId={clientId}>
                <GoogleLoginButton
                  label="Regjistrohu me Google"
                  onSuccess={handleGoogleResponse}
                />
              </GoogleOAuthProvider>
            </div>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-sm text-gray-700 hover:text-black transition">
                Tashmë keni llogari? <strong>Kyquni tani</strong>
              </Link>
            </div>
          </div>
        </main>

        <Footer />
      </div>

      {unavailableOpen ? (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
          role="presentation"
          onClick={continueAsGuest}
        >
          <div
            className="w-full max-w-md rounded-2xl bg-white p-6 shadow-[0_16px_40px_rgba(0,0,0,0.18)]"
            role="dialog"
            aria-modal="true"
            aria-labelledby="reg-unavailable-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="reg-unavailable-title" className="text-xl font-bold text-black">
              Regjistrimi i padisponueshëm
            </h3>
            <p className="mt-3 text-sm leading-6 text-gray-700">
              {unavailableMessage || 'Regjistrimi nuk është i mundur për momentin. Provoni më vonë.'}
            </p>
            <button
              type="button"
              onClick={continueAsGuest}
              className="mt-6 w-full rounded-lg bg-black px-4 py-3 text-sm font-semibold text-white transition hover:bg-gray-900"
            >
              Vazhdoni si guest
            </button>
          </div>
        </div>
      ) : null}


      {/* <div className="min-h-screen bg-gradient-to-br from-indigo-100 to-blue-200 flex flex-col">
        <Toaster />
        <Header />

        <main className="flex-grow flex items-center justify-center px-4 pt-16 pb-10">
          <div className="w-full max-w-4xl bg-white bg-opacity-90 backdrop-blur-lg shadow-2xl rounded-2xl p-6 sm:p-12 mt-24">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-indigo-800">Krijoni Llogari</h2>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Emri"
                    {...register("fname", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.fname && <p className="text-red-500 text-sm mt-1">Kërkohet Emri</p>}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Mbiemri"
                    {...register("lname", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.lname && <p className="text-red-500 text-sm mt-1">Kërkohet Mbiemri</p>}
                </div>
              </div>

              <input
                type="email"
                placeholder="Email"
                {...register("email", { required: true })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">Kërkohet Email</p>}

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Numri i telefonit"
                    {...register("phone", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.phone && <p className="text-red-500 text-sm mt-1">Kërkohet numri</p>}
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Adresa"
                    {...register("address", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.address && <p className="text-red-500 text-sm mt-1">Kërkohet Adresa</p>}
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    placeholder="Qyteti"
                    {...register("city", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.city && <p className="text-red-500 text-sm mt-1">Kërkohet Qyteti</p>}
                </div>
                <div>
                  <input
                    type="date"
                    {...register("dob", { required: true })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-500 focus:ring-2 focus:ring-indigo-500"
                  />
                  {errors.dob && <p className="text-red-500 text-sm mt-1">Kërkohet Data e lindjes</p>}
                </div>
              </div>

              <div>
                <select
                  {...register("gender", { required: true })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-500 focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="">Zgjidh gjininë</option>
                  <option value="Male">Mashkull</option>
                  <option value="Female">Femër</option>
                </select>
                {errors.gender && <p className="text-red-500 text-sm mt-1">Kërkohet Gjinia</p>}
              </div>

              <input
                type="password"
                placeholder="Fjalëkalimi"
                {...register("password", { required: true })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              />
              {errors.password && <p className="text-red-500 text-sm mt-1">Kërkohet Fjalëkalimi</p>}

              <button
                type="submit"
                className="w-full mt-4 bg-yellow-500 hover:bg-yellow-600 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition"
              >
                <span>Regjistrohu</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 9l3 3-3 3m8-3H3" />
                </svg>
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link to="/login" className="text-sm text-gray-600 hover:text-yellow-600 transition">
                Tashmë keni llogari? <strong>Kyquni tani</strong>
              </Link>
            </div>
          </div>
        </main>

        <Footer />
      </div> */}
    </>
  );
}




// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom'
// import { useForm } from "react-hook-form";
// import { LoginAction, RegAction } from "../../action";
// import { useDispatch, useSelector } from "react-redux";
// import logonew from '../../assets/images/logonew-login.png';
// import toast, { Toaster } from 'react-hot-toast';

// export default function Reg() {
//   const dispatch = useDispatch()
//   const navigate = useNavigate();
//   const regUsers = useSelector(state => state.productData.users)
//   const notifyErr = () => toast.error('Llogaria ekziston tashmë');
//   const { register, handleSubmit, formState: { errors } } = useForm();
//   const obj = {}
//   const [inputField, setInputField] = useState(obj)
//   const inputsHandler = (e) => {
//     console.log(e.target.name)
//     let name = e.target.name;
//     let value = e.target.value;
//     inputField[name] = value;
//     setInputField(inputField);
//   }

//   const checkoutData = (datax) => {
//     var data = {
//       fname: datax.fname,
//       lname: datax.lname,
//       email: datax.email,
//       address: datax.address,
//       city: datax.city,
//       dateOfBirth: datax.dob,
//       gender: datax.gender,
//       phoneNumber: datax.phone,
//       password: datax.password,
//       role: "Buyer"
//     };
//     console.log(data)
//     dispatch(RegAction(data))
//     // navigate("/");
//     // alert("Regjistrimi i suksesshëm");
//   }


//   useEffect(() => {
//     if (regUsers.message == "Surprize...") {
//       notifyErr()
//     }
//     if (regUsers.token?.length > 0) {
//       navigate("/");
//     }
//   }, [regUsers])



//   return (
//     <>
//       <div className="sm:h-screen bg-gray-100">
//         <Toaster />
//         <div className="sm:h-screen flex flex-col items-center justify-center  w-full ">
//           <Link className='imglink' to="/" className="sm:hidden py-2 ">
//             <img src={logonew} className="logo" alt="" srcSet="" />
//           </Link>
//           <div className="flex flex-col bg-white shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-xl w-11/12 sm:w-4/12 max-w-md">
//             <div className="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800">
//               Krijoni llogari
//             </div>
//             <button className="relative mt-6 border rounded-md py-1 text-sm text-gray-800 bg-gray-100 hover:bg-gray-200">
//               <span className="absolute left-0 top-0 flex items-center justify-center h-full w-10 text-blue-500">
//                 <i className="fab fa-facebook-f" />
//               </span>
//               <span>Kyquni me Facebook</span>
//             </button>
//             <button className="relative mt-4 border rounded-md py-1 text-sm text-gray-800 bg-gray-100 hover:bg-gray-200">
//               <span className="absolute left-0 top-0 flex items-center justify-center h-full w-10 text-gray-500">
//                 <i className="fab fa-google" />
//               </span>
//               <span>Kyquni me Google</span>
//             </button>
//             <div className="relative mt-6 h-px bg-gray-300">
//               <div className="absolute left-0 top-0 flex justify-center w-full -mt-2">
//                 <span className="bg-white px-4 text-xs text-gray-500 uppercase">
//                   OSE KRIJO ME EMAIL
//                 </span>
//               </div>
//             </div>
//             <div className="mt-6">
//               <form onSubmit={handleSubmit(checkoutData)} >
//                 <div className="flex flex-col py-1">
//                   <label
//                     htmlFor="email"
//                     className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
//                   >
//                     Emri:
//                   </label>
//                   <div className="relative">
//                     <div className="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
//                       <svg
//                         className="h-4 w-4"
//                         fill="none"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                         <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
//                         <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
//                         <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
//                       </svg>              </div>
//                     <input
//                       id="email"
//                       type="text"
//                       className="text-sm sm:text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-1 focus:outline-none focus:border-blue-400"
//                       name="fname" onChange={inputsHandler} value={inputField.fname} {...register("fname", { required: true })} />
//                   </div>
//                   {errors.fname && <span className='text-red-500 pt-1'>Kërkohet Emri</span>}
//                 </div>
//                 <div className="flex flex-col py-1">
//                   <label
//                     htmlFor="email"
//                     className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
//                   >
//                     Mbiemri:
//                   </label>
//                   <div className="relative bg-red">
//                     <div className="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
//                       <svg
//                         className="h-4 w-4"
//                         fill="none"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                         <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
//                         <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
//                         <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
//                       </svg>
//                     </div>
//                     <input
//                       id="email"
//                       type="text"
//                       className="text-sm sm:text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-1 focus:outline-none focus:border-blue-400"
//                       name="lname" onChange={inputsHandler} value={inputField.lname} {...register("lname", { required: true })} />
//                   </div>
//                   {errors.lname && <span className='text-red-500 pt-1'>Kërkohet Mbiemri</span>}
//                 </div>


//                 <div className="flex flex-col py-1">
//                   <label
//                     htmlFor="email"
//                     className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
//                   >
//                     Email:
//                   </label>
//                   <div className="relative">
//                     <div className="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
//                       <svg
//                         className="h-4 w-4"
//                         fill="none"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
//                       </svg>
//                     </div>
//                     <input
//                       id="email"
//                       type="email"
//                       name="email"
//                       className="text-sm sm:text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-1 focus:outline-none focus:border-blue-400"
//                       name="email" onChange={inputsHandler} value={inputField.email} {...register("email", { required: true })} />
//                   </div>
//                   {errors.email && <span className='text-red-500 pt-1'>Kërkohet Email</span>}
//                 </div>
//                 <div className="flex flex-col py-1">
//                   <label
//                     htmlFor="password"
//                     className="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
//                   >
//                     Fjalëkalimi:
//                   </label>
//                   <div className="relative">
//                     <div className="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
//                       <span>
//                         <svg
//                           className="h-4 w-4"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                         </svg>
//                       </span>
//                     </div>
//                     <input
//                       id="password"
//                       type="password"
//                       name="password"
//                       className="text-sm sm:text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-1 focus:outline-none focus:border-blue-400"
//                       name="password" onChange={inputsHandler} value={inputField.password} {...register("password", { required: true })} />
//                   </div>
//                   {errors.password && <span className='text-red-500 pt-1'>Kërkohet Fjalëkalimi</span>}
//                 </div>


//                 <div className="flex w-full mt-3">
//                   <button
//                     type="submit"
//                     className="flex items-center justify-center focus:outline-none text-white text-sm sm:text-base  hover:bg-[#e39600] rounded py-2 w-full transition duration-150 ease-in"
//                     style={{ backgroundColor: "#fca700" }}>
//                     <span className="mr-2 uppercase">Regjistrohu</span>
//                     <span>
//                       <svg
//                         className="h-6 w-6"
//                         fill="none"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
//                       </svg>
//                     </span>
//                   </button>
//                 </div>
//               </form>
//             </div>
//             <div className="flex justify-center items-center mt-6">
//               <Link
//                 to="/login"
//                 className="inline-flex items-center font-bold text-gray-500 hover:text-[#e39600] text-xs text-center"
//               >
//                 <span className="ml-2">Tashmë keni llogari ? Kyquni tani</span>
//               </Link>
//             </div>
//           </div>
//         </div>



//       </div>
//     </>
//   )
// }